import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layout/fullLayout/loadable/loadable";
import { OOPSError } from "../views/authentication/OopsError";
import { AuthorizedRoute } from "./AuthorizedRoute";
import { ProtectedRoute } from "./ProtectedRoutes";
import { PublicRoute } from "./PublicRoute";
import { BeforeProfile } from "../views/Profile/UsersList/UsersList";
import { element } from "prop-types";
import { ALLOWED_MODULES, MODULE_IDS, MODULE_NAMES } from "../constants/enums";
import path from "path";
import { MasterRouter } from "../views/master/router/master.router";

/* ***Layouts**** */
const FullLayout = Loadable(
  lazy(() =>
    import("../layout/fullLayout/FullLayout").then(({ FullLayout }) => ({
      default: FullLayout,
    }))
  )
);
const BlankLayout = Loadable(
  lazy(() => import("../layout/blankLayout/BlankLayout"))
);
/* ***End Layouts**** */

const Error = Loadable(
  lazy(() =>
    import("../views/authentication/Error").then(({ Error }) => ({
      default: Error,
    }))
  )
);

/* ****Pages***** */

const Dashboard = Loadable(
  lazy(() =>
    import("../views/dashboard/Dashboard/Dashbaord").then(({ Dashboard }) => ({
      default: Dashboard,
    }))
  )
);

const Login = Loadable(
  lazy(() =>
    import("../views/authentication/Login").then(({ Login }) => ({
      default: Login,
    }))
  )
);
const AccessDenied = Loadable(
  lazy(() =>
    import("../views/authentication/AccessDenied").then(({ AccessDenied }) => ({
      default: AccessDenied,
    }))
  )
);

const Leads = Loadable(
  lazy(() =>
    import("../views/leads/Leads").then(({ Leads }) => ({
      default: Leads,
    }))
  )
);

const ManageLead = Loadable(
  lazy(() =>
    import("../views/leads/ManageLead").then(({ ManageLead }) => ({
      default: ManageLead,
    }))
  )
);

const PublicManageLead = Loadable(
  lazy(() =>
    import("../views/PublicLead/publicManageLead").then(
      ({ PublicManageLead }) => ({
        default: PublicManageLead,
      })
    )
  )
);

const ViewOpportunites = Loadable(
  lazy(() =>
    import("../views/opportunites/opportunites").then(
      ({ ViewOpportunites }) => ({
        default: ViewOpportunites,
      })
    )
  )
);
const ManageOpportunity = Loadable(
  lazy(() =>
    import("../views/opportunites/CreateOppurtunity/manageOpportunites").then(
      ({ ManageOpportunity }) => ({
        default: ManageOpportunity,
      })
    )
  )
);

const CustomersList = Loadable(
  lazy(() =>
    import("../views/customers/CustomersList").then(({ CustomersList }) => ({
      default: CustomersList,
    }))
  )
);
const CustomerOverview = Loadable(
  lazy(() =>
    import(
      "../views/customers/components/CustomerOverview/CustomerOverview"
    ).then(({ CustomerOverview }) => ({
      default: CustomerOverview,
    }))
  )
);

const EditCustomer = Loadable(
  lazy(() =>
    import("../views/customers/EditCustomer").then(({ EditCustomer }) => ({
      default: EditCustomer,
    }))
  )
);

const ManageUser = Loadable(
  lazy(() =>
    import("../views/Profile/UsersList/ManageUser").then(({ ManageUser }) => ({
      default: ManageUser,
    }))
  )
);

const ViewProfile = Loadable(
  lazy(() =>
    import("../views/Profile/ViewProfile/ViewProfile").then(
      ({ ViewProfile }) => ({
        default: ViewProfile,
      })
    )
  )
);
const MyProfileView = Loadable(
  lazy(() =>
    import("../views/Profile/UsersList/MyProfileView").then(
      ({ MyProfileView }) => ({
        default: MyProfileView,
      })
    )
  )
);
const TemplatesList = Loadable(
  lazy(() =>
    import("../views/Templates/TemplatesList").then(({ TemplatesList }) => ({
      default: TemplatesList,
    }))
  )
);

const MessagingTemplate = Loadable(
  lazy(() =>
    import("../views/Templates/Template").then(({ MessagingTemplate }) => ({
      default: MessagingTemplate,
    }))
  )
);

const FeeStructureList = Loadable(
  lazy(() =>
    import("../views/FeeStructure/FeeStructureList").then(
      ({ FeeStructure }) => ({
        default: FeeStructure,
      })
    )
  )
);

const SecurityDashboard = Loadable(
  lazy(() =>
    import("../views/Security/CreateSecurityGroup").then(
      ({ CreateSecurityGroup }) => ({ default: CreateSecurityGroup })
    )
  )
);

const ListSecurityGroups = Loadable(
  lazy(() =>
    import("../views/Security/ListSecurityGroups").then(
      ({ ListSecurityGroups }) => ({ default: ListSecurityGroups })
    )
  )
);

const ForgotPassword = Loadable(
  lazy(() =>
    import("../views/authentication/ForgotPassword").then(
      ({ ForgotPassword }) => ({
        default: ForgotPassword,
      })
    )
  )
);
const CreateOpportunites = Loadable(
  lazy(() =>
    import("../views/opportunites/CreateOppurtunity/CreateOppurtunity").then(
      ({ CreateOpportunites }) => ({ default: CreateOpportunites })
    )
  )
);
const RoleGroup = Loadable(
  lazy(() =>
    import("../views/Security/roleGroup/RoleGroupTable").then(
      ({ RoleGroupTable }) => ({ default: RoleGroupTable })
    )
  )
);

const AssignOptionalFee = Loadable(
  lazy(() =>
    import("../views/FeeStructure/AssignOptionalFee").then(
      ({ AssignOptionalFee }) => ({ default: AssignOptionalFee })
    )
  )
);

const PayTypeWiseFeeReport = Loadable(
  lazy(() =>
    import("../views/reports/paymentReport").then(
      ({ PayTypeWiseFeeReport }) => ({ default: PayTypeWiseFeeReport })
    )
  )
);

const GroupedStudent = Loadable(
  lazy(() =>
    import("../views/reports/groupedStudent").then(({ GroupedStudent }) => ({
      default: GroupedStudent,
    }))
  )
);

const RecieptReport = Loadable(
  lazy(() =>
    import("../views/reports/Reciept").then(({ RecieptReport }) => ({
      default: RecieptReport,
    }))
  )
);

const CourseandBatch = Loadable(
  lazy(() =>
    import("../views/reports/courseandBatch").then(({ CourseandBatch }) => ({
      default: CourseandBatch,
    }))
  )
);

// const StudentDetailedReport = Loadable(
// 	lazy(() => import("../views/reports/StudentDetaild").then(({ StudentDetailedReport }) => ({ default: StudentDetailedReport }))
// )
// );

export const Router = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <FullLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        exact: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: "/dashbaord",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[]} allowFullAccess>
            <Dashboard />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/leads",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[ALLOWED_MODULES.LEADS]}>
            <Leads />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/leads/manage",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[ALLOWED_MODULES.LEADS]}>
            <ManageLead />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/leads/manage/:uuid",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[ALLOWED_MODULES.LEADS]}>
            <ManageLead />
          </AuthorizedRoute>
        ),
      },

      // ------------- opportunites ----------------------------
      {
        path: "/opportunites",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[ALLOWED_MODULES.OPPORTUNITY]}>
            <ViewOpportunites />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/opportunites/manage",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[MODULE_NAMES.OPPORTUNITY]}>
            <ManageOpportunity />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/opportunites/manage/:oppId",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[ALLOWED_MODULES.OPPORTUNITY]}>
            <ManageOpportunity />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/view-customers",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[ALLOWED_MODULES.STUDENT]}>
            <CustomersList />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/customer-overview/:id",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[ALLOWED_MODULES.STUDENT]}>
            <CustomerOverview />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/edit-customer/:id",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[ALLOWED_MODULES.STUDENT]}>
            <EditCustomer />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/templates",
        exact: true,
        element: (
          <AuthorizedRoute
            allowFullAccess
            moduleIds={[ALLOWED_MODULES.TEMPLATES]}
          >
            <TemplatesList />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/fee-structure",
        exact: true,
        element: (
          <AuthorizedRoute
            allowFullAccess
            moduleIds={[ALLOWED_MODULES.FEE_STRUCTURE]}
          >
            <FeeStructureList />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/templates/manage-template",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[ALLOWED_MODULES.TEMPLATES]}>
            <MessagingTemplate />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/templates/manage-template/:templateCode",
        exact: true,
        element: (
          <AuthorizedRoute moduleIds={[ALLOWED_MODULES.TEMPLATES]}>
            <MessagingTemplate />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/view-profile",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleIds={[ALLOWED_MODULES.USERS]}>
            <ViewProfile />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/users/manage",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleIds={[ALLOWED_MODULES.USERS]}>
            <ManageUser />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/users",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleIds={[ALLOWED_MODULES.USERS]}>
            <BeforeProfile />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/users/manage/:userId",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleIds={[ALLOWED_MODULES.USERS]}>
            <ManageUser />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/my-profile/:uuid",
        exact: true,
        element: (
          <ProtectedRoute>
            <MyProfileView />
          </ProtectedRoute>
        ),
      },

      {
        path: "/security/role-groups",
        exact: true,
        element: (
          <ProtectedRoute>
            <RoleGroup />
          </ProtectedRoute>
        ),
      },

      // {
      // 	path: "/my-profile/:uuid",
      // 	exact: true,
      // 	element: (
      // 		<ProtectedRoute>
      // 			<MyProfileView />
      // 		</ProtectedRoute>
      // 	),
      // },

      {
        path: "/list-security-groups",
        exact: true,
        element: (
          <AuthorizedRoute
            allowFullAccess
            moduleIds={[ALLOWED_MODULES.SECURITY]}
          >
            <ListSecurityGroups />
          </AuthorizedRoute>
        ),
      },

      {
        path: "/create-security-group",
        exact: true,
        element: (
          <AuthorizedRoute
            allowFullAccess
            moduleIds={[ALLOWED_MODULES.SECURITY]}
          >
            <SecurityDashboard />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/assign-optional-fee",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleIds={[ALLOWED_MODULES.USERS]}>
            <AssignOptionalFee />
          </AuthorizedRoute>
        ),
      },

      {
        path: "payment-type-report",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleIds={[ALLOWED_MODULES.USERS]}>
            <PayTypeWiseFeeReport />
          </AuthorizedRoute>
        ),
      },
      {
        path: "student-report",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleIds={[ALLOWED_MODULES.USERS]}>
            <GroupedStudent />
          </AuthorizedRoute>
        ),
      },
      // {
      // 	path: "student-detailed-report",
      // 	exact: true,
      // 	element: (
      // 		<AuthorizedRoute
      // 			allowFullAccess
      // 			moduleIds={[ALLOWED_MODULES.USERS]}
      // 		>
      // 			<StudentDetailedReport />
      // 		</AuthorizedRoute>
      // 	),

      // },
      {
        path: "receipts-report",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleIds={[ALLOWED_MODULES.USERS]}>
            <RecieptReport />
          </AuthorizedRoute>
        ),
      },
      {
        path: "course-report",
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleIds={[ALLOWED_MODULES.USERS]}>
            <CourseandBatch />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/create-security-group/:roleId",
        exact: true,
        element: (
          <AuthorizedRoute
            allowFullAccess
            moduleIds={[ALLOWED_MODULES.SECURITY]}
          >
            <SecurityDashboard />
          </AuthorizedRoute>
        ),
      },
      {
        path: "/secuirty-role-duplicate/:roleId",
        exact: true,
        element: (
          <AuthorizedRoute
            allowFullAccess
            moduleIds={[ALLOWED_MODULES.SECURITY]}
          >
            <SecurityDashboard isDuplicate />
          </AuthorizedRoute>
        ),
      },

      { path: "access", element: <AccessDenied /> },
      { path: "error", element: <OOPSError /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ].concat(MasterRouter),
  },

  // --------------------------------TASK ROUTING----------------------------------------------

  {
    path: "/auth",
    element: (
      <PublicRoute>
        <BlankLayout />
      </PublicRoute>
    ),
    children: [
      { path: "404", element: <Error /> },
      { path: "login", element: <Login /> },
      { path: "reset-password", element: <ForgotPassword /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: "/student-lead-form",
    element: <PublicManageLead />,
  },
];
